import React, { useState } from 'react';
import { 
  FaCar, FaShieldAlt, FaCheckCircle, FaChevronDown, 
  FaHandHoldingUsd, FaFileAlt, FaPercent, FaRegClock, FaBolt 
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const CarLoan = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      q: "What is the typical eligibility criteria for a car loan?",
      a: "Eligibility depends on factors such as your age, employment type (salaried or self-employed), monthly income, credit score (CIBIL score), and existing financial obligations. Generally, applicants aged 21 to 65 with a stable income source qualify easily."
    },
    {
      q: "What is the maximum loan amount and tenure I can get?",
      a: "Most lenders finance up to 80% to 100% of the car's on-road price, depending on your financial profile and the vehicle model. Repayment tenures typically range from 1 year to 7 years (12 to 84 months)."
    },
    {
      q: "How fast is the car loan approval and disbursal process?",
      a: "With our streamlined digital documentation and banking partnerships, pre-approvals can be secured within hours, and final loan disbursals typically occur within 24 to 48 hours once all verification checks are complete."
    },
    {
      q: "Can I pre-close or part-pay my car loan before tenure ends?",
      a: "Yes, most partner lenders allow pre-closure or part-payments. Depending on the lender's policy and whether your loan is floating or fixed-rate, nominal foreclosure charges or zero charges may apply after a specified lock-in period."
    }
  ];

  return (
    <main className="car-loan-page">
      <Helmet>
  {/* Basic SEO */}
  <title>Car Loan Services in Hyderabad | Best Auto Loan Advisors | Lotoswealth</title>

  <meta
    name="description"
    content="Lotoswealth offers Car Loan Services in Hyderabad, helping individuals secure the best new and used car loans with competitive interest rates, quick approvals, flexible EMI options, refinancing, and expert loan advisory services."
  />

  <meta
    name="keywords"
    content="Car Loan Hyderabad, Car Loan Services Hyderabad, Auto Loan Hyderabad, Vehicle Loan Hyderabad, New Car Loan Hyderabad, Used Car Loan Hyderabad, Best Car Loan Hyderabad, Car Loan Advisor Hyderabad, Car Finance Hyderabad, Car Loan Interest Rates Hyderabad, Car Loan EMI Hyderabad, Car Loan Refinancing Hyderabad, Car Loan Balance Transfer Hyderabad, Vehicle Finance Hyderabad, Auto Finance Hyderabad, Loan Advisor Hyderabad, Financial Advisor Hyderabad, Loan Services Hyderabad, Lotoswealth"
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="Lotoswealth" />
  <meta name="language" content="English" />

  <link
    rel="canonical"
    href="https://www.lotoswealth.com/car-loan"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Lotoswealth" />
  <meta
    property="og:url"
    content="https://www.lotoswealth.com/car-loan"
  />
  <meta
    property="og:title"
    content="Car Loan Services in Hyderabad | Lotoswealth"
  />
  <meta
    property="og:description"
    content="Get the best Car Loan Services in Hyderabad with Lotoswealth. Compare lenders, enjoy competitive interest rates, flexible EMI options, quick approvals, and expert financial guidance."
  />
  <meta
    property="og:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Car Loan Services in Hyderabad | Lotoswealth"
  />
  <meta
    name="twitter:description"
    content="Apply for the best Car Loan in Hyderabad with Lotoswealth. Quick approvals, attractive interest rates, flexible EMIs, and expert loan advisory for new and used cars."
  />
  <meta
    name="twitter:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />
</Helmet>
      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>
        
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img 
            src="/images/car-loan.jpg" 
            alt="Car Loan Solutions" 
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
              Car Loan Solutions
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Drive Home Your Dream Car With Competitive Rates & Quick Approvals
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth. Buying your dream vehicle should be an exciting milestone, not a bureaucratic hurdle. Our car loan advisory services connect you with top-tier banking partners to secure fast, flexible, and competitively priced financing tailored to your budget.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Whether you are purchasing a brand-new luxury vehicle, an electric car, or a certified pre-owned model, we handle the complexities of paperwork, negotiations, and loan structuring so you can get behind the wheel seamlessly.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Enjoy high-value funding, minimal documentation, transparent terms, and dedicated support throughout your car financing journey.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. WHY CHOOSE OUR CAR LOANS (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">
                Why Finance Your Car Through Lotoswealth?
              </h2>
              <p className="text-muted line-height-lg">
                Walking into a single bank for a car loan often limits your bargaining power and exposes you to rigid terms. By leveraging our multi-bank partnerships, we shop across top financial institutions to secure the lowest interest rates and highest loan-to-value (LTV) ratios available.
              </p>
              <p className="text-muted line-height-lg">
                We simplify the entire borrowing lifecycle—from calculating affordable EMIs to expediting paperwork—ensuring a fast, transparent, and stress-free financing experience.
              </p>
            </div>
            <div className="col-lg-6 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-5">
                <h4 className="fw-bold text-teal mb-3">Key Financing Benefits</h4>
                <ul className="list-unstyled text-muted mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Attractive Interest Rates:</strong> Negotiated rates lower than standard retail offers.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>High Loan-to-Value (LTV):</strong> Up to 100% on-road price funding options.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Lightning-Fast Approvals:</strong> Pre-approvals within hours and rapid disbursal.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Flexible Tenures:</strong> Repayment schedules customized from 1 to 7 years.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          3. OUR CAR LOAN OFFERINGS (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white" style={{ backgroundImage: "url('/images/lotoswealth-bg.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🚗 Our Car Financing Options</h2>
            <p className="text-white">Customized loan products tailored for every type of vehicle purchase.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-lg-4 col-md-6 animate-slide-up delay-1">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaCar size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">New Car Loans</h5>
                <p className="text-muted small">Competitive interest rates and high funding percentages for brand-new hatchbacks, sedans, SUVs, and luxury vehicles straight from the showroom.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-2">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaHandHoldingUsd size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Used / Pre-Owned Car Loans</h5>
                <p className="text-muted small">Attractive financing terms and quick valuation assessments for certified pre-owned vehicles, making quality mobility affordable.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-3">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaPercent size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">EV (Electric Vehicle) Loans</h5>
                <p className="text-muted small">Special green-mobility financing rates and discounted processing fees to encourage sustainable, eco-friendly vehicle adoption.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-4">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaBolt size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Instant Pre-Approved Loans</h5>
                <p className="text-muted small">Exclusive pre-approved credit lines for existing clients with minimal paperwork and immediate fund disbursal capabilities.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-5">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaFileAlt size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Balance Transfer & Top-Up</h5>
                <p className="text-muted small">Refinance your existing high-interest car loan at a lower rate or secure additional top-up funds against your vehicle with ease.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-6">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaShieldAlt size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Structured EMI Programs</h5>
                <p className="text-muted small">Flexible repayment options, including step-up or balloon EMIs designed to match your projected income growth trajectory.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          4. OUR 5-STEP LOAN PROCESS (Dark Slate)
      ========================================= */}
      <section className="py-5 text-white" style={{ backgroundColor: '#0a192f' }}>
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🔄 Our Simple Car Loan Process</h2>
            <p className="text-light opacity-75">From application to keys in hand in 5 easy steps.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-md-6 col-lg-4 animate-slide-up delay-1">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 1 – Application & Consultation</h5>
                <p className="small text-muted mb-0">Share your vehicle preference and financial details with our loan specialists to identify the best bank offers.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 2 – Offer Comparison</h5>
                <p className="small text-muted mb-0">We compare interest rates, processing fees, and tenure terms across multiple lenders to get you the optimal deal.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 3 – Digital Documentation</h5>
                <p className="small text-muted mb-0">Submit minimal KYC, income proof, and vehicle quotation documents securely through our digital portal.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 animate-slide-up delay-4">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 4 – Fast Approval</h5>
                <p className="small text-muted mb-0">Quick credit underwriting and formal sanction letter issuance directly from the lending institution.</p>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 animate-slide-up delay-5">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 5 – Disbursal & Delivery</h5>
                <p className="small text-muted mb-0">Funds are disbursed directly to the dealer or seller, allowing you to take immediate delivery of your new car.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          5. WHO WE SERVE & WHY CHOOSE US (Soft Blue-Gray)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#eef2f5' }}>
        <div className="container py-4">
          <div className="row g-5">
            
            {/* Target Audience */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">👥 Who Can Apply for a Car Loan?</h3>
              <p className="text-muted small mb-4">Our car financing solutions support a wide array of applicants:</p>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "Salaried Professionals", "Self-Employed Individuals",
                  "Business Owners & Directors", "First-Time Car Buyers",
                  "Luxury Vehicle Enthusiasts", "EV Adopters",
                  "Pre-Owned Car Buyers", "Existing Lotoswealth Clients"
                ].map((item, idx) => (
                  <span key={idx} className="badge bg-white text-dark border p-2 shadow-sm fs-6">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Why Choose Lotoswealth */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h3 className="fw-bold mb-3 text-dark">🏆 Why Trust Lotoswealth for Loans?</h3>
                <p className="text-muted small mb-4">Securing financing requires transparent negotiation and fast turnaround times. Clients trust us because we offer:</p>
                <div className="row g-3">
                  {[
                    "Multi-Bank Rate Comparison", "Negotiated Low Interest Rates",
                    "High Loan-to-Value (LTV) Funding", "Minimal Documentation & Paperwork",
                    "Dedicated Loan Relationship Officers", "Fast 24-48 Hour Disbursals",
                    "Transparent Terms & No Hidden Fees", "End-to-End Dealer Coordination"
                  ].map((item, idx) => (
                    <div key={idx} className="col-md-6 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                      <span className="small text-muted fw-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          6. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
            <p className="text-muted">Common queries regarding Car Loans & Financing</p>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button 
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown 
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`} 
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================
          7. FINAL CTA SECTION (Deep Navy)
      ========================================= */}
      <section className="py-5 text-white text-center" style={{ backgroundColor: '#0f1e2d' }}>
        <div className="container py-4">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">Ready to Drive Home Your Dream Car?</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2 mx-auto" style={{ maxWidth: '600px' }}>
            Secure the best car loan rates and fast approvals with Lotoswealth. Connect with our financing experts today.
          </p>
          <button className="btn-custom-teal hover-lift px-5 py-3 fs-5 border-0 rounded text-white shadow animate-slide-up delay-3">
            Apply for a Car Loan Today
          </button>
        </div>
      </section>

    </main>
  );
};

export default CarLoan;